import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { IkitState } from "./kit.types";

const selectDomain = (state: any) => state.kitReducer;

export const kit = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.kit
);

export const singlekit = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.singlekit
);

export const successMessage = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.kitSuccessMesssage
);

export const kitError = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.kitError
);

export const kitActivityInProcess = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.iskitActivityInProcess
);

export const addKitActivityInProcess = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.addKit
);

export const fileSuccessMessage = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.fileMessage
);

export const totalPages = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.totalPages
);


export const totalRecords = createDraftSafeSelector(
  selectDomain,
  (kit: IkitState) => kit.totalRecords
);
